import React from 'react';
import Icon from 'components/AppIcon';

const DeleteConfirmModal = ({ recipient, onConfirm, onClose }) => {
  return (
    <div className="fixed inset-0 z-[400] flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-background/80 backdrop-blur-sm" onClick={onClose} />
      <div className="relative bg-card border border-border rounded-lg shadow-xl w-full max-w-sm">
        <div className="p-5">
          <div className="flex items-start space-x-3">
            <div className="flex-shrink-0 w-9 h-9 bg-destructive/10 rounded-full flex items-center justify-center">
              <Icon name="Trash2" size={18} className="text-destructive" strokeWidth={2} />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground">Delete Recipient</h3>
              <p className="text-sm text-muted-foreground mt-1">
                Are you sure you want to permanently delete{' '}
                <span className="font-medium text-foreground">{recipient?.name}</span>? This action cannot be undone.
              </p>
            </div>
          </div>
        </div>
        <div className="flex items-center justify-end space-x-3 px-5 py-4 border-t border-border">
          <button
            onClick={onClose}
            className="px-4 py-2 text-sm font-medium text-muted-foreground hover:text-foreground hover:bg-muted rounded-md transition-colors"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            className="px-4 py-2 text-sm font-medium bg-destructive text-destructive-foreground rounded-md hover:bg-destructive/90 transition-colors"
          >
            Delete
          </button>
        </div>
      </div>
    </div>
  );
};

export default DeleteConfirmModal;
